import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { Router, Scroll } from '@angular/router';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Request } from 'express';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import packageJson from '../../package.json';
import { REQUEST } from '../express.tokens';
import { EnvironmentActions } from './core/actions';
import { TokenService } from './core/services/token.service';
import { splashTransition } from './shared/animations/splash-transitions';
import { getCurrentLangFromPath, getProtocolHostnameAndPort } from './shared/helpers/location';
import { Device } from './shared/models/device';
import { Identity } from './shared/models/identity';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        splashTransition
    ]
})
export class AppComponent implements OnInit {

    identity$: Observable<Identity>;
    identityUpdating$: Observable<boolean>;
    device$: Observable<Device>;
    route$: Observable<any>;

    loading = true;

    subscriptions: Subscription[] = [];
    identitySync: Identity;
    toFullfill: any[] = [];

    constructor(
        private readonly store$: Store<fromRoot.State>,
        private tokenService: TokenService,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        @Optional() @Inject(REQUEST) private req: Request,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.device$ = this.store$.select(fromRoot.getDevice);
        this.route$ = this.store$.select(fromRoot.getRoute);
        this.identityUpdating$ = this.store$.select(fromRoot.getActiveIdentityUpdating);
        this.identity$ = this.store$.select(fromRoot.getActiveIdentity);

        this.identity$.subscribe(identity => this.identitySync = identity);
        // Scitylana
        this.router.events.pipe(
            filter(event => {
                if (event instanceof Scroll) {
                    this.toFullfill.push(event);
                }
                let isTokenExpired = true;
                if (!!this.identitySync?.token?.token) {
                    isTokenExpired = this.tokenService.isTokenExpired(this.identitySync.token.token);
                }
                return !!this.identitySync && !isTokenExpired;
            })
        ).subscribe(() => {
            if (this.toFullfill.length) {
                this.parseRoutingEvent(this.toFullfill);
            }
        });
    }

    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            // update tag html lang according to current language path
            const pathName = isPlatformBrowser(this.platformId) ? window.location.pathname : this.req.originalUrl;
            const currentLang = getCurrentLangFromPath(pathName);
            this.document.documentElement.lang = currentLang;
        }
    }

    parseRoutingEvent(events: any[]) {
        if (isPlatformBrowser(this.platformId)) {
            const filteredEvents = events.filter(event => (event instanceof Scroll && !event.routerEvent.url.match(/^\/redirect/)));
            filteredEvents.map(event => {
                const urlTarget = event.routerEvent.url;
                this.store$.dispatch(EnvironmentActions.CreateEventScitylana({
                    event: {
                        event: 'pageView',
                        url: getProtocolHostnameAndPort() + urlTarget,
                        referer: document.referrer,
                        date: new Date().toISOString(),
                        clientName: environment.clientName,
                        clientVersion: packageJson.version,
                    }
                }));
            }, this);
            this.toFullfill = [];
        }
    }
}
